import { Box } from "@mui/system";

import CustomSelectAvatar from "./../../../CustomSelectAvatar/index";
import UseWindowDimensions from "./../../../../../utils/windowSize";

const AvatarSelector = () => {
  const { height } = UseWindowDimensions();

  return (
    <Box
      sx={{
        border: "2px solid",
        borderBottom: 0,
        borderColor: "black.main",
        borderRadius: "16px 16px 0 0",
        width: "100%",
        padding: "24px 16px",
        height: height + -280 + "px",
      }}
    >
      <CustomSelectAvatar header />
    </Box>
  );
};

export default AvatarSelector;
